<script lang="ts" setup>
import { ErrorMessage } from 'vee-validate';
import { toValue } from 'vue';
import { useFormField } from '../hooks/useFormField';
import type { IFormMessageProps } from '../types/FormMessage';

const props = defineProps<IFormMessageProps>();

const { name, formMessageId, error } = useFormField();
</script>

<template>
  <ErrorMessage
    class="form-message"
    :id="formMessageId"
    data-slot="form-message"
    as="div"
    :name="toValue(name)"
    v-slot="{}"
  ></ErrorMessage>
</template>

<style scope>
.form-message {
  margin: 4px 0 4px;
  color: var(--x-error-6);
  font-size: var(--x-text-12-size);
  line-height: var(--x-text-12-line-height);
}
</style>
